import React from 'react';
import CustomText from '../../../Typography/CustomText/CustomText';
import Box from '../../../Box/Box';

interface SiteKitWorkspaceTitleProps {
  children: string;
}
const SiteKitWorkspaceTitle = ({ children }: SiteKitWorkspaceTitleProps) => (
  <Box bottom="large">
    <CustomText align="left" as="span" size={children.length < 15 ? '24' : '20'} weight="semibold" whiteSpace="normal">
      {children}
    </CustomText>
  </Box>
);

SiteKitWorkspaceTitle.displayName = 'SiteKit.Sidebar.WorkspaceSelector.Title';

export { SiteKitWorkspaceTitle, SiteKitWorkspaceTitleProps };
